import React from 'react'
import { CardContent,CardDescription,CardHeader, CardTitle,Card } from './card'
import { Button } from './button'
import Image1 from './Image1.png'
import Image2 from './Image2.png'
import Image3 from './Image3.png'
export default function Projects() {
  return (
    <div className='w-full h-fit bg-card p-4' id='project'>
      
      <div className='w-full text-center  text-4xl text-primary mb-10 font-semibold'>About My <span className='font-[Pacifico] text-primary'>Projects.</span></div>
            
      <div className='w-full text-center text-primary/75  text-lg  mb-10 '>this section shows current projects of mine.</div>
<div className='h-fit w-full flex flex-wrap justify-center items-center gap-12'>


      
<Card className='h-fit w-[350px] bg-card flex flex-col gap-[20px] justify-center items-center p-2 '>

<img src={Image2} className='rounded-lg border border-muted'>
</img>

<CardContent className='flex flex-col justify-center items-start gap-5'>
<CardTitle className='text-2xl'>CalorECal</CardTitle>
<CardDescription className='w-[300px] h-[100px]'>
A manual accurate Calorie tracker which uses local storage to store the data of entered food has a minimalistic user-interface uses charts to show user's progress.
</CardDescription>
<CardDescription className='p-1 bg-muted rounded'>
    Made with <i class="fa-brands fa-react mr-1 text-blue-500"></i>
    <i class="fa-brands fa-js mr-1 text-yellow-500"></i>
    <span className='w-fit p-1 rounded-lg text-white font-semibold'>/Shadcn.ui</span>.
</CardDescription>

 <a href='https://calorecal2.netlify.app'>
 <Button variant='outline' className='text-lime-500 font-mono'>visit link <i class="fa-solid fa-up-right-from-square"></i></Button>
  </a></CardContent>




</Card>

<Card className='h-fit w-[350px] bg-card flex flex-col gap-[20px] justify-center items-center p-2 '>

<img src={Image1} className='rounded-lg border border-muted '>
</img>

<CardContent className='flex flex-col justify-center items-start gap-5'>
<CardTitle className='text-2xl'>Ricen.ai</CardTitle>
<CardDescription className='w-[300px] h-[100px]'>
Ricen Helpful Assistant is a web-based AI chatbot designed to provide info on any topic Built on the advanced Google Gemini framework.
<span className='text-destructive'> not visitble currently
 .</span>
</CardDescription>
<CardDescription className='p-1 bg-muted rounded'>
    Made with <i class="fa-brands fa-html5 mr-1 text-orange-500"></i>
    <i class="fa-brands fa-js mr-1 text-yellow-500"></i>
    <span className='w-fit p-1 rounded-lg text-sky-500 font-semibold'>Taiwlind</span>.
</CardDescription>

<Button variant='outline' className='text-lime-500 font-mono'>visit link <i class="fa-solid fa-up-right-from-square"></i></Button>

</CardContent>




</Card>

<Card className='h-fit w-[350px] bg-card flex flex-col gap-[20px] justify-center items-center p-2 '>

<img src={Image3} className='rounded-lg border border-muted '>
</img>

<CardContent className='flex flex-col justify-center items-start gap-5'>
<CardTitle className='text-2xl'>Editox</CardTitle>
<CardDescription className='w-[300px] h-[100px]'>
Layer Based photoEditing Software made here user can create layers on images or images on images and can apply various effects and filters.It supports all google fonts,gradients,etc. 
</CardDescription>
<CardDescription className='p-1 bg-muted rounded'>
    Made with <i class="fa-brands fa-html5 mr-1 text-orange-500"></i>
    <i class="fa-brands fa-js mr-1 text-yellow-500"></i>
    <i class="fa-brands fa-css3-alt mr-1 text-blue-500"></i>
</CardDescription>

<a href='https://editox.netlify.app'>
<Button variant='outline' className='text-lime-500 font-mono'>visit link <i class="fa-solid fa-up-right-from-square"></i></Button>
  </a> </CardContent>




</Card>
</div>

    </div>
  )
}
